import React, { useState } from "react";
import { useFormik } from 'formik';

import EditTextForm from "../../components/EditTextForm/EditTextForm";
import { COLORS } from "../../constants/colors";
import Paint from "../../components/Paint/Paint";
import globalStyle from "../../styles/globalStyle.module.css";
import LoadingButton from "../../components/LoadingButton/LoadingButton";
import './Configuration.css';
import { useAuth } from "../../../contexts/auth";
import { getError, openNotification, tryCatch } from "../../constants/Utilities";
import ModalContainer from "../../components/ModalContainer/ModalContainer";


// Internal interface
interface Problem {
    title: string;
    description: string;
}

// Props
interface Props {
    setVisibleConf: React.Dispatch<React.SetStateAction<boolean>>;
}

const Report: React.FC<Props> = ({ setVisibleConf }) => {

    // States
    const [loading, setLoading] = useState<boolean>(false);
    const { reportProblem } = useAuth();

    //Methods
    const validations = (values: Problem) => {
        const errors: any = {};
        if (!values.title) {
            errors.title = 'Requerido';
        }

        if (!values.description) {
            errors.description = 'Requerido';
        }

        return errors;
    };


    // Form
    const ReportForm = useFormik({
        initialValues: { title: '', description: '' },
        validate: validations,
        onSubmit: (values: Problem) => handleReportProblem(values.title, values.description)
    });

    //Handles
    const handleReportProblem = (errorTitle: string, errorDescription: string) => {
        tryCatch(() => {
            setLoading(true);
            reportProblem(errorTitle, errorDescription)
                .then((response) => {
                    openNotification('success', `Problema reportado`, response);
                    setVisibleConf(false);
                })
                .catch((error) => {
                    openNotification('error', 'Error', getError(error));
                })
                .finally(() => setLoading(false));
        })
    }

    return (
        <ModalContainer>
            <p className="password_title">Reportar Problema</p>
            <div className="password_marginInput">
                <label>Título:</label>
                <div className="password_input">
                    <EditTextForm
                        value={ReportForm.values.title}
                        onChange={ReportForm.handleChange}
                        backgroundcolor={'transparent'}
                        name={"title"}
                        placeholder={"Titulo"}
                        borderColor={COLORS.blue_main(1)}
                        textColor={COLORS.blue_main(1)}
                        active={!loading}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ReportForm.errors.title && ReportForm.errors.title}</Paint>
                    </p>
                </div>
            </div>

            <div className="password_marginInput">
                <label>Descripción:</label>
                <div className="password_input">
                    <EditTextForm
                        value={ReportForm.values.description}
                        onChange={ReportForm.handleChange}
                        backgroundcolor={'transparent'}
                        name={"description"}
                        placeholder={"Descripción"}
                        borderColor={COLORS.blue_main(1)}
                        textColor={COLORS.blue_main(1)}
                        active={!loading}
                        type={'textarea'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ReportForm.errors.description && ReportForm.errors.description}</Paint>
                    </p>
                </div>
            </div>

            <LoadingButton
                type="button"
                method={ReportForm.handleSubmit}
                title={"Enviar"}
                loading={loading.toString()}
                background={COLORS.blue_active}
                color={COLORS.white_color1}
                style={{ padding: '3px', width: '200px', margin: 'auto 15% auto auto', height: '32px' }}
                fontsize={16}
            />
        </ModalContainer>
    );
}

export default Report;